

exports.__esModule = true;
exports.$xoFrameBustRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var $xoFrameBustRoute = exports.$xoFrameBustRoute = _index.$Route.extend('$xoFrameBustRoute', {

    path: 'framebust',
    directive: _directive.$xoFrameBustPageDirective,

    auth: false,

    children: []
});

angular.value("$xoFrameBustRoute", $xoFrameBustRoute);
_index.$Route;

_directive.$xoFrameBustPageDirective;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-framebust/route.js
 ** module id = 425
 ** module chunks = 1
 **/